import EmbedNewPlayerSTART from 'components/Embeds/EmbedNewPlayerSTART';
import EmbedNewPlayerSUCCESS from 'components/Embeds/EmbedNewPlayerSUCCESS';
import EmbedNewPlayerREDIRECT_TO_PAYMENT from 'components/Embeds/EmbedNewPlayerREDIRECT_TO_PAYMENT';
import EmbedNewPlayerSTART_WITH_PAYMENT from 'components/Embeds/EmbedNewPlayerSTART_WITH_PAYMENT';
import OpenReplayTracker from 'components/OpenReplayTracker';
import usePageTitle from 'hooks/usePageTitle';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

const EmbedNewPlayer = () => {
  const [state, setState] = React.useState('START');
  usePageTitle('New User - HMS');

  const [searchParams] = useSearchParams();
  const usePayment = searchParams.get('usePayment');

  console.log(usePayment);

  const generateBody = () => {
    switch (state) {
      case 'START':
        if (usePayment) {
          return <EmbedNewPlayerSTART_WITH_PAYMENT setState={setState} />;
        } else {
          return <EmbedNewPlayerSTART setState={setState} />;
        }
      case 'REDIRECT_TO_PAYMENT':
        return <EmbedNewPlayerREDIRECT_TO_PAYMENT setState={setState} />;
      case 'SUCCESS':
        return <EmbedNewPlayerSUCCESS setState={setState} />;
    }
  }

  return (
    <>
        <OpenReplayTracker 
          projectKey={process.env.REACT_APP_OPENREPLAY_KEY}
          userId={'Anonymous'} 
          disableSecureMode={process.env.REACT_APP_OPENREPLAY_DISABLE_SECURE_MODE == 'true'} 
          metadata={{ ENVIRONMENT: process.env.REACT_APP_OPENREPLAY_ENVIRONMENT }}
          silent={true} />

      {generateBody()}
    </>
  )
}

export default EmbedNewPlayer